export default function InnovationGapCard({ reason: { heading, description, imgKey } }) {
  return (
    <div className={`bg-white rounded-lg border-2 border-accent-color p-5 flex flex-col items-center gap-4 shadow-lg`}>
      <div className="rounded-full border-4 border-accent-color size-24 overflow-hidden">
        <img src={require(`../../../images/the-need/${imgKey}`)} className="size-full object-cover object-center" />
      </div>
      <div>
        <div className="text-lg font-semibold text-accent-color">{heading}</div>
        <div className="text-gray-600">{description}</div>
      </div>
    </div>
  );
}
